import { createSlice } from "@reduxjs/toolkit";
import {
  customRatingThunk,
  dashboardItemSold,
  dashboardItemSoldThunk,
  dashEarning,
  dashEarningThunk,
  dashItemSoldThunk,
  dashNewOrder,
  dashNewOrderThunk,
  dashPastTrendsThunk,
  dashRevenuThunk,
  dashSellerProductCategoriesThunk,
  dashSellerThunk,
  dashTopSellerProductsThunk,
  dashTotalProducts,
  dashTotalProductsThunk,
  GetOrderStatistics,
  productReviewsThunk,
  recentOrdersThunk,
  shopByCategoryThunk,
} from "../thunks/dashboardThunk";
import { createDynamicSlice } from ".";

const dashRevenuSlice = createDynamicSlice({
  name: "dashRevenuSlice",
  thunk: dashRevenuThunk,
});

const dashTopSellerSlice = createDynamicSlice({
  name: "dashTopSellerProductsSlice",
  thunk: dashTopSellerProductsThunk,
  listMode: true,
});

const dashPastTrendsSlice = createDynamicSlice({
  name: "dashPastTrendsSlice",
  thunk: dashPastTrendsThunk,
});

const recentOrdersSlice = createDynamicSlice({
  name: "recentOrdersSlice",
  thunk: recentOrdersThunk,
  listMode: true,
});

// const shopByCategorySlice = createDynamicSlice({
//   name: "shopByCategorySlice",
//   thunk: shopByCategoryThunk,
// });

const initialStateShopCatReviews = {
  loading: false,
  error: null,
  dateFilter: null,
};
const shopByCategorySlice = createSlice({
  name: "shopByCategorySlice",
  initialState: initialStateShopCatReviews,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(shopByCategoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shopByCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.dateFilter = action.payload;
      })
      .addCase(shopByCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

const productReviewsSlice = createDynamicSlice({
  name: "productReviewsSlice",
  thunk: productReviewsThunk,
  listMode: true,
});

const customRatingSlice = createDynamicSlice({
  name: "customRatingSlice",
  thunk: customRatingThunk,
});

const dashboardItemSoldSlice = createDynamicSlice({
  name: "dashboardItemSoldSlice",
  thunk: dashboardItemSoldThunk,
});

const dashNewOrderSlice = createDynamicSlice({
  name: "dashNewOrderSlice",
  thunk: dashNewOrderThunk,
});

const dashEarningSlice = createDynamicSlice({
  name: "dashEarningSlice",
  thunk: dashEarningThunk,
});


const dashProductsSlice = createDynamicSlice({
  name: "dashTotalProductSlice",
  thunk: dashTotalProductsThunk,
});

const orderStatisticsSlice = createDynamicSlice({
  name: "orderStatisticsSlice",
  thunk: GetOrderStatistics,
    keyedById: true,
});


export const dashRevenuReducer = dashRevenuSlice.reducer;
export const dashTopSellerReducer = dashTopSellerSlice.reducer;
export const dashPastTrendsReducer = dashPastTrendsSlice.reducer;
export const dashboardProductReviewsReducer = productReviewsSlice.reducer;
export const dashboardItemSoldReducer = dashboardItemSoldSlice.reducer;
export const dashboardEarningReducer = dashEarningSlice.reducer;
export const dashProductsReducer = dashProductsSlice.reducer;
export const dashboardRatingSliceReducer = customRatingSlice.reducer;
export const dashboardShopCatSliceReducer = shopByCategorySlice.reducer;
export const dashboardRecentOrdersReducer = recentOrdersSlice.reducer;
export const dashboardNewOrderReducer = dashNewOrderSlice.reducer;
export const orderStatisticsReducer = orderStatisticsSlice.reducer;

